import React from 'react';
import { useTranslation } from 'react-i18next';
import style from './TermsAndConditions.scss';
import { Divider } from 'drift-ui';
import { formatDate } from 'utils/utils';
import { LegalText } from 'client-experience-toolbox';

const TermAndConditionText: React.FC<LegalText> = ({ title, text, effective_date }) => {
  const { t } = useTranslation();

  return (
    <div className={style.leftAlignedText}>
      <h1 className={style.title}>{title}</h1>
      <Divider />
      <div className={style.bodyText}>{text}</div>
      {effective_date && (
        <p>
          {t('updated')} {formatDate(effective_date)}
        </p>
      )}
    </div>
  );
};

export default TermAndConditionText;
